<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology Handles</h2>
        <h3>Mat Dowel Handles</h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="dowel_handle_1@1x.jpg"
              src2="dowel_handle_1@2x.jpg"
              alt="Photo of Mat Dowel Handles"
            />
            <photo
              @setFeature="setFeatureImg"
              src="dowel_handle_2@1x.jpg"
              src2="dowel_handle_2@2x.jpg"
              alt="Photo of Mat Dowel Handles attached to mat"
            />
            <photo
              @setFeature="setFeatureImg"
              src="dowel_handle_3@1x.jpg"
              src2="dowel_handle_3@2x.jpg"
              alt="Close-up photo of Mat Dowel Handles attached to mat"
            />
          </photo-grid>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology Handles</h2>
              <h3>Mat Dowel Handles</h3>
              <p>
                These removable Mat Dowel Handles insert into the Mat Conversion and are used exclusively for Mat exercises on the Reformer. The Mat Dowel Handles help to activate your arm and back connection for safe overhead Mat exercises, strengthening your back and enabling you to feel your two-way stretch.
              </p>
              <p>
                Dowel Handle Dimensions: L: 13.5” (34.3cm), W: 2” (5.1cm), H: 3.5” (6.4cm), Weight: .63lbs. (.3kg)
              </p>
              <p>
                <em>*Installed handles will extend approximately 9” (22.9cm) on either side of the mat conversion.</em>
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >90-Day Limited Warranty</icon-link>
            </section>

          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";

export default {
  name: "dowelhandles",

  metaInfo: {
    title: "Pilates Handles - Contrology Mat Handles - Mat Dowel Handles",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Help activate your arm and back connection for safe overhead mat exercises by adding these Contrology Mat Dowel Handles to your Reformer Mat Conversion."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      product: {
        label: "Select a Handle",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41267963396289,
          partnumber: 17628,
          price: 75,
          name: "Mat Dowel Handles",
          available: true
        },
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.handle-title {
  font-weight: 700;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
